import { Card, CardContent } from "@/components/ui/card"
import { Trophy } from "lucide-react"

interface PerformanceEmptyStateProps {
  loading: boolean
}

export const PerformanceEmptyState = ({ loading }: PerformanceEmptyStateProps) => (
  <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
    <CardContent className="p-8 text-center">
      <Trophy className="h-12 w-12 mx-auto text-muted-foreground dark:text-gray-400 mb-4" />
      <h3 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">
        {loading ? "Cargando datos de rendimiento..." : "Sin datos de rendimiento"}
      </h3>
      <p className="text-muted-foreground dark:text-gray-300">
        {loading
          ? "Obteniendo información de las standing del torneo..."
          : "Los datos de rendimiento estarán disponibles una vez que el torneo tenga rondas jugadas."}
      </p>
    </CardContent>
  </Card>
)
